import React from 'react';
import * as commonApi from '../../../api/common-api';
import Loading from 'react-loading';
import axios from 'axios';
import 'react-select/dist/react-select.css';

let querystring = require('querystring');
let Progress = require('react-progressbar');
let progress_val = 0;
const file_limit = 25 * 1024 * 1024;
let uploading = false;


class CommentBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comment: "",
            file_upload: undefined,
            file_ext: "",
            preview: ""
        };
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {}

    handleFileUpload = (evt) => {
        if (evt.target.files.length > 0) {
            let fileUpload = evt.target.files[0];
            if (fileUpload.size > file_limit) {
                commonApi.showAlert("Max file size is 25MB!");
                this.refs.file_input.value = '';
                return;
            }
            let Extension = fileUpload.name.substring(fileUpload.name.lastIndexOf('.') + 1).toLowerCase();
            var allowedExtensions = ['xlsx', 'xls', 'doc', 'docx', 'ppt', 'pptx', 'txt', 'pdf', 'zip', 'rar', '7z', 'rtf'];
            var imageExt = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];
            if (imageExt.indexOf(Extension) !== -1 || allowedExtensions.indexOf(Extension) !== -1) {
                let reader = new FileReader();
                reader.onloadend = () => {
                    this.setState({
                        file_upload: fileUpload,
                        preview: reader.result,
                        file_ext: Extension
                    });
                }
                reader.readAsDataURL(fileUpload);
            } else {
                commonApi.showAlert("Only accept: documents, images, compress files");
                this.refs.file_input.value = '';
            }
        }
    }

    clearFile = (evt) => {
        this.setState({file_upload: undefined})
        this.refs.file_input.value = '';
    }

    handleAttClick = (evt) => {
        this.refs.file_input.value = '';
        this.refs.file_input.click();
    }

    handleComment = (evt) => {
        if (evt.key === 'Enter' && uploading === false) {

            let comment = this.state.comment.trim();
            if (comment.length === 0) {
                commonApi.showAlert("Write a comment please!");
            } else {
                let data = new FormData();
                if (this.state.file_upload !== undefined) {
                    uploading = true;
                    data.append('file', this.state.file_upload);
                }
                data.append('comment', comment);
                let api = '/code/api_experiences.php?api=postExperientialComments';
                if (this.props.joined != undefined) {
                    data.append('id_joined', this.props.joined.id_joined);
                }
                if (this.props.comment != undefined) {
                    data.append('id_comment_comment', this.props.comment.id_comment);
                }

                axios.post(api, data, {
                    progress: (progressEvent) => {
                        progress_val = (progressEvent.loaded / progressEvent.total) * 100;
                        this.forceUpdate();
                    }
                })
                    .then(response => {
                        if (response.data.status === 1) {
                            uploading = false;
                            if (Object.keys(response.data.data).length > 0) {
                                this.setState({
                                    comment: "",
                                    file_upload: undefined,
                                    preview: ""
                                });

                                if (response.data.comment !== undefined && Object.keys(response.data.comment).length > 0) {
                                    this.props.onChange(response.data.comment);
                                }
                                this.props.onComment(response.data.data);
                            } else {
                                commonApi.showAlert("Please try again!");
                            }
                        } else {
                            commonApi.showAlert("Please try again!");
                            uploading = false;
                            this.forceUpdate();
                        }
                        return response;
                    }).catch(error => {
                    uploading = false;
                    this.forceUpdate();
                });
            }
        }
    }

    handleChange = (evt) => {
        this.setState({comment: evt.target.value});
    }

    render() {
        if (parseInt(this.props.enable_ask) !== 1) {
            return (
                <div className="post_comment_box">  </div>
            );
        }
        let avatar = '/static/img/appimg/common-noavatar-sm.jpg';
        let user = this.props.user
        if (user == undefined) {
            return (
                <div className="post_comment_box">
                    <div style={{color: "#545454"}}>
                        <div className="center_div"><Loading type='spinningBubbles' color='rgba(82, 158, 204, 1)' width={20} height={20}/></div>
                    </div>
                </div>
            );
        }

        if (user.image_avatar_account > 0) {
            avatar = user.link_thumb_file;
        }


        // file
        let imageExt = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];
        let file_div = ''
        if (this.state.file_upload != undefined) {
            let extension = this.state.file_ext

            if (imageExt.indexOf(extension) !== -1) {
                file_div = <div>
                    <img className="img_upload" src={this.state.file_upload != undefined ? this.state.preview : ""}/>
                    <div className="img_close"><a onClick={this.clearFile.bind(this)}>X</a></div>
                </div>
            }
            else {
                file_div = <div>
                    <b>{this.state.file_upload.name}</b>
                    <div className="img_close"><a onClick={this.clearFile.bind(this)}>X</a></div>
                </div>
            }
        }

        return (
            <div className="post_comment_box">
                <div className="left_box"><img className="img_circle_s" src={avatar}/></div>
                <div className="right_box">
                    <input ref="input"
                           name="post_comment"
                           placeholder="Ask question or post an update..."
                           value={this.state.comment}
                           onChange={this.handleChange.bind(this)}
                           onKeyPress={this.handleComment.bind(this)}
                    />
                    <a onClick={this.handleAttClick.bind(this)}><img className="att_icon hide-el" src="/static/img/appimg/icon_com_att.png"/></a>
                    <div className={this.state.file_upload != undefined ? "file_upload" : "hide-el"}>
                        {file_div}
                    </div>
                </div>
                <div className={uploading ? "upload_progress" : "hide-el"}>
                    <Progress completed={progress_val}/>
                </div>
                <input ref="file_input" className="hide-el" type="file" onChange={this.handleFileUpload.bind(this)} accept=".xlsx,.xls,image/*,.doc, .docx,.ppt,.pptx,.txt,.pdf,.zip,.rar,.7z,.rtf"/>
            </div>
        );
    }
}

export default CommentBox;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/experiential/CommentBox.js
 **/